import React from 'react';
import { Brain, Building2, Target, CheckCircle2 } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-funeral-dark">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-serif text-center text-funeral-gold mb-4">
          Tentang Kami
        </h2>
        <div className="divider"></div>

        <div className="max-w-4xl mx-auto space-y-12">
          <div className="text-center bg-funeral-secondary/50 p-8 rounded-lg border border-funeral-border">
            <div className="flex justify-center mb-4">
              <div className="bg-funeral-gold/10 p-4 rounded-full">
                <Brain className="text-funeral-gold" size={40} />
              </div>
            </div>
            <h3 className="text-2xl font-serif text-funeral-light mb-4">Tentang Kenangan.AI</h3>
            <p className="text-funeral-light leading-relaxed">
              <strong className="text-funeral-gold">Kenangan.AI</strong> adalah layanan Artificial Intelligence saat acara kedukaan berbasis WhatsApp yang mudah digunakan. Diakses lewat QR Code di rumah duka. Tanpa perlu download aplikasi apapun.
            </p>
          </div>

          <div className="text-center bg-funeral-secondary/50 p-8 rounded-lg border border-funeral-border">
            <div className="flex justify-center mb-4">
              <div className="bg-funeral-gold/10 p-4 rounded-full">
                <Building2 className="text-funeral-gold" size={40} />
              </div>
            </div>
            <h3 className="text-2xl font-serif text-funeral-light mb-4">Pengembang</h3>
            <p className="text-funeral-light">
              <strong className="text-funeral-gold">Kenangan.AI</strong> adalah layanan AI dari <strong className="text-funeral-gold">PT AI Indonesia</strong>.
            </p>
          </div>

          <div className="text-center bg-funeral-secondary/50 p-8 rounded-lg border border-funeral-border">
            <div className="flex justify-center mb-4">
              <div className="bg-funeral-gold/10 p-4 rounded-full">
                <Target className="text-funeral-gold" size={40} />
              </div>
            </div>
            <h3 className="text-2xl font-serif text-funeral-light mb-6">Tujuan Layanan</h3>
            <ul className="space-y-3 text-funeral-light max-w-2xl mx-auto">
              <li className="flex items-start gap-3">
                <CheckCircle2 className="text-funeral-gold mt-1 flex-shrink-0" size={20} />
                <span>Membantu keluarga mengenang almarhum</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="text-funeral-gold mt-1 flex-shrink-0" size={20} />
                <span>Membantu tamu memahami informasi dengan jelas</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="text-funeral-gold mt-1 flex-shrink-0" size={20} />
                <span>Mengumpulkan doa dan pesan penguatan</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="text-funeral-gold mt-1 flex-shrink-0" size={20} />
                <span>Mengumpulkan foto dan video dari tamu</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle2 className="text-funeral-gold mt-1 flex-shrink-0" size={20} />
                <span>Menyerahkan semuanya kepada keluarga</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
